import axiosApiInstance from "./axios";
import axiosCloudfrontInstance from "./axiosCloudfront";

const options = {
  crossDomain: true,
  // headers: {
  //   "Replace-Host": process.env.REACT_APP_CDN_DOMAIN,
  // },
};
const APIS = {
  simulacionEnd: async (obj, jwt) => {
    options.headers = {
      authorization: jwt,
    };
    return axiosApiInstance.post(`/vespertino/simulacion/end`, obj, options);
  },
  simulacionStart: async (obj) => {
    return axiosApiInstance.post(`/vespertino/simulacion/start`, obj, options);
  },
  startSimulation: async (obj) => {
    return axiosApiInstance.post(`vespertino/simulacion/start`, obj, options);
  },
  estudiantePut: async (obj, jwt) => {
    options.headers = {
      authorization: jwt,
    };
    return axiosApiInstance.put(`/vespertino/estudiante`, obj, options);
  },
  estudianteGet: async (tipoDoc, numDoc) => {
    return axiosApiInstance.get(
      `/vespertino/estudiante/` + tipoDoc + "/" + numDoc
    );
  },
  getOpeningData: async () => {
    return axiosApiInstance.get(`/aperturas/apertura/3`, options);
  },
  getRegiones: async () => {
    return axiosCloudfrontInstance.get(`/backend_data/regiones.json`);
  },
  getCarreras: async () => {
    return axiosCloudfrontInstance.get(
      `/backend_data/carreras_vespertino.json`
    );
  },
  sendCertificado: async (obj, certificado, jwt) => {
    options.headers = {
      authorization: jwt,
    };
    return axiosApiInstance.post(
      `/vespertino/certificado/enviar/` + certificado,
      obj,
      options
    );
  },
};

export default APIS;
